// @core/api/endpoints/payment/charge_payment.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ChargePaymentRequest,
  ChargePaymentResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Charge payment
 * Creates a payment with authorize+capture in one step. Routes to optimal provider via smart routing and cascades on soft declines.
 */
export async function ChargePayment(
  data: ChargePaymentRequest,
  options?: RequestOptions
): Promise<ChargePaymentResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payments/charge`;
  const requestOptions = options;
  return client.post<ChargePaymentResponse>(requestPath, data, requestOptions);
}
